import React from "react";
import {
  EuiCard,
  EuiFlexGroup,
  EuiFlexItem,
  EuiIcon,
  EuiImage,
  EuiPanel,
  EuiText,
} from "@elastic/eui";

import finance from "./undraw_personal_finance_tqcd.png";
import connect from "./connect-account.png";
import reachGoals from "./reach-goals.png";
import talkToFriends from "./talk-to-friends.png";

class LandingPage extends React.Component {
  render() {
    return (
      <>
        <EuiFlexGroup justifyContent="spaceEvenly">
          <EuiFlexItem grow={false}>
            <EuiText>
              <h1>Meet Penge</h1>
            </EuiText>
          </EuiFlexItem>
        </EuiFlexGroup>
        <EuiFlexGroup justifyContent="spaceEvenly" alignItems="center">
          <EuiFlexItem grow={false}>
            <EuiPanel color="primary">
              <EuiImage size="l" alt="penge" src={finance} />
            </EuiPanel>
          </EuiFlexItem>
          <EuiFlexItem grow={false}>
            <EuiPanel color="primary">
              <EuiText>
                <h2>
                  Penge is a way to push yourself with your personal finance
                  goals
                </h2>
                <h3>
                  Think Apple Fitness, but for your finances. Compete with
                  friends, track your progress, and get financially fit.
                </h3>
              </EuiText>
            </EuiPanel>
          </EuiFlexItem>
        </EuiFlexGroup>
        <EuiFlexGroup justifyContent="spaceEvenly">
          <EuiFlexItem grow={false}>
            <EuiText>
              <h1>How It Works</h1>
            </EuiText>
          </EuiFlexItem>
        </EuiFlexGroup>
        <EuiFlexGroup justifyContent="spaceEvenly">
          <EuiFlexItem grow={false}>
            <EuiCard
              textAlign="left"
              image={
                <div>
                  <img src={connect} alt="connect account" />
                </div>
              }
              title="1. Connect your accounts"
              description="Connect using our secure integrations with Plaid so you don't have to manually update your transaction data."
            />
          </EuiFlexItem>
          <EuiFlexItem grow={false}>
            <EuiCard
              textAlign="left"
              image={
                <div>
                  <img src={reachGoals} alt="reach your goals" />
                </div>
              }
              title="2. Reach your goals"
              description="Set goals, like saving an emergency fund, paying off debt, or staying under budget."
            />
          </EuiFlexItem>
          <EuiFlexItem grow={false}>
            <EuiCard
              textAlign="left"
              image={
                <div>
                  <img src={talkToFriends} alt="talk to your friends" />
                </div>
              }
              title="3. Share your success"
              description="Share updates with your friends and see their updates so every stays motivated."
            />
          </EuiFlexItem>
        </EuiFlexGroup>
        <EuiFlexGroup justifyContent="spaceEvenly">
          <EuiFlexItem grow={false}>
            <EuiText>
              <h1>Got Questions?</h1>
            </EuiText>
          </EuiFlexItem>
        </EuiFlexGroup>
        <EuiFlexGroup justifyContent="spaceEvenly" alignItems="center">
          <EuiFlexItem grow={false}>
            <EuiPanel color="primary">
              <EuiText>
                <h2>
                  We're still developing Penge, but we'd love to hear what you
                  think.
                </h2>
                <h3>
                  Send an email to brittanyjoiner15(at)gmail.com to get more
                  info.
                </h3>
              </EuiText>
            </EuiPanel>
          </EuiFlexItem>
        </EuiFlexGroup>
      </>
    );
  }
}

export default LandingPage;
